import { gql } from 'graphql-request'

export const getUserQuery = gql`
  {
    user {
      featureFlags
      id
      name
      email
      name
      email
      lastSignInAt
      createdAt
      emailVerified
      shouldIdentifyOnCIO
      claims
      profilePictureUrl
      subscription {
        isPro
        isPremium
        plan
        availableCredits
        proTrialExpiresAt
        activeStripeCurrency
        currentMonthlyUsage
        mustCancelRevenuecatPremium
        details {
          pending
          autoRenew
          providerName
          planCycle
          expireDate
          providerGateway
        }
      }
      preferences {
        communication {
          activity {
            push
            email
          }
          updates {
            push
            email
          }
        }
        defaultSeparation {
          type
        }
        chordSkillLevel
        demoPlaylist {
          optOut
          hideFromLibrary
        }
      }
      goals
      instruments {
        skillLevel
        instrumentId
      }
      actionNeeded {
        hasTermsToAccept
      }
    }
    getFlags(flags: ["abTestDemoPlaylist"])
  }
`
